import React from 'react';
import { handleStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  GDSStyleObject,
  StackLayout,
  Modal,
  ParagraphText,
  HeadingText,
  Button,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import { SHARED_LIBRARY_ASSET_KEYS } from '../../types/shared-library.types';
import COBQuestioner from '../../assets/json/COB_QUESTIONER.json';

export function ConfirmationModal() {
  // const { onClose } = props;
  const is355 = useMediaQuery(queryHelpers.between([300, 359]));
  return (
    <Modal.Root>
      <Modal.Trigger>
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-end',
              position: 'relative',
              height: '40px',
              width: '40px',
              top: '30px',
              '@mobile': {
                left: is355 ? '20px' : '10px',
              },
            } as GDSStyleObject
          }
        >
          <img
            src={
              handleStaticAsset(SHARED_LIBRARY_ASSET_KEYS.CROSS_ICON) as string
            }
            alt="close the online form"
            width="50px"
          />
        </Box>
      </Modal.Trigger>
      <Modal.Content
        showCloseButton
        padding="$none"
        layout={{ '@initial': 'standard', '@mobile': 'fullscreen' }}
        width={{ '@initial': 438, '@mobile': '100%' }}
        css={{
          '.GDS-modal-overlay': { background: 'rgba(136, 136, 136, 0.7)' },
        }}
      >
        <StackLayout
          css={{ textAlign: 'center', padding: '$three $three' }}
          horizontalAlignment="stretch"
        >
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              } as GDSStyleObject
            }
          >
            {' '}
            <img
              src={
                handleStaticAsset(
                  SHARED_LIBRARY_ASSET_KEYS.EXIT_WARNING,
                ) as string
              }
              alt="cross icon"
              width="158px"
              style={{ cursor: 'pointer' }}
            />
          </Box>
          <Modal.Title>
            <HeadingText
              level="display"
              size="sm"
              css={{ padding: '$oneAndHalf $none' } as GDSStyleObject}
            >
              {COBQuestioner.COB.ALERT.HEADING}
            </HeadingText>
          </Modal.Title>
          <ParagraphText emphasis="subtle">
            {COBQuestioner.COB.ALERT.CONTENT}
          </ParagraphText>

          <Button
            width="fillContainer"
            priority="primary"
            css={{
              marginTop: '$three',
              marginBottom: '$one',
              background: '#0074C9',
            }}
          >
            {COBQuestioner.COB.Buttons.LEAVEFORM}
          </Button>

          <Modal.Close>
            <Button
              width="fillContainer"
              priority="tertiary"
              quiet
              css={{ color: '#434B51', border: '1px #434B51 solid' }}
            >
              {COBQuestioner.COB.Buttons.KEEPGOING}
            </Button>
          </Modal.Close>
        </StackLayout>
      </Modal.Content>
    </Modal.Root>
  );
}
